import './CalendarItem.css';
export var calendarButton = '_1basjc2-3-15-1';
export var currentIndicator = '_1basjc1-3-15-1';
export var headerButton = '_1basjc3-3-15-1';
export var outOfScopeDay = '_1basjc0-3-15-1';